/** This is a Container.  Place all code
 * portions that deal with the server
 * or Redux in this file.  It is not
 * for handling display templates */

import { connect } from 'react-redux';
import * as actions from './PDFActions';
import WorkflowView from './PDFView';
import {
  selectHasFirmSettingsAccess,
  selectPortalName,
} from '../CommonSelectors/CommonAreaSelector';

let clientId = null;

const mapStateToProps = (state, ownProps) => {
  const subdivision = state.PDF[ownProps.clientId];
  clientId = ownProps.clientId || state.Workflow.current_clientId;

  return {
    ...subdivision,
    fpId: ownProps.fpId,
    sections: subdivision ? subdivision.sections : { included: [], excluded: [] },
    name: subdivision ? subdivision.name : null,
    isFirmLevelTemplate: subdivision ? subdivision.isFirmLevelTemplate : false,
    enabled: subdivision && subdivision.canGeneratePdf,
    clientId,
    downloadErrors: state.PDF.downloadErrors,
    portalName: selectPortalName(state),
    hasFirmSettingsAccess: selectHasFirmSettingsAccess(state),
    hasEnhancedReportExperience: subdivision && subdivision.enhancedReportExperience,
    savedReportsPath: subdivision ? state.PDF.savedReportsPath : null,
  };
};

const mapDispatchToProps = dispatch => ({
  fetch_data(clientId) {
    dispatch(actions.fetch_data(clientId));
  },
  removeItemIncluded(index) {
    dispatch(actions.remove_item('included', index, clientId));
  },
  addItemIncluded(item, position) {
    dispatch(actions.add_item('included', item, clientId, position));
  },
  moveItemIncluded(drag_index, hover_index) {
    dispatch(actions.move_item('included', drag_index, hover_index, clientId));
  },

  removeItemExcluded(index) {
    dispatch(actions.remove_item('excluded', index, clientId));
  },
  addItemExcluded(item) {
    dispatch(actions.add_item('excluded', item, clientId));
  },
  moveItemExcluded(drag_index, hover_index) {
    dispatch(actions.move_item('excluded', drag_index, hover_index, clientId));
  },
  changeModifiableItem(item, list, clientId) {
    dispatch(actions.change_item(item, list, clientId));
  },

  saveTemplate(sections, name, clientId, isFirmLevelTemplate) {
    dispatch(actions.save_template(sections, name, clientId, isFirmLevelTemplate));
  },
  deleteTemplate(name, clientId, isFirmLevelTemplate) {
    dispatch(actions.delete_template(name, clientId, isFirmLevelTemplate));
  },
  deleteSection(index, list, clientId) {
    dispatch(actions.delete_section(index, list, clientId));
  },
  getTemplate(name, clientId, isFirmLevelTemplate) {
    dispatch(actions.get_template(name, clientId, isFirmLevelTemplate));
  },
  download_pdf(sections, clientId, fpId) {
    dispatch(actions.downloadPdf(sections, clientId, fpId));
  },
  set_warnings(warnings, clientId) {
    dispatch(actions.set_warnings(warnings, clientId));
  },
  clearDownloadErrors() {
    dispatch(actions.setDownloadErrors(null));
  },
});

const Workflow = connect(mapStateToProps, mapDispatchToProps)(WorkflowView);

export default Workflow;
